import { useMemo } from 'react';
import { FILE_UPLOAD_DIALOG_FIELD_NAME } from '@sib/files';
import { useTranslation } from '@sib/i18n';
import { z } from 'zod';

export const useMultipleFilesUploadFormSchema = (
  fieldName: string = FILE_UPLOAD_DIALOG_FIELD_NAME
) => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      z.object({
        [fieldName]: z.object({
          files: z
            .array(z.instanceof(File))
            .min(1, { message: t('validation.required') }),
        }),
      }),
    [fieldName, t]
  );
};

export type MultipleFilesUploadFormValues = z.infer<
  ReturnType<typeof useMultipleFilesUploadFormSchema>
>;

export const getDefaultMultipleFilesUploadValues =
  (): MultipleFilesUploadFormValues => ({
    [FILE_UPLOAD_DIALOG_FIELD_NAME]: { files: [] },
  });
